import type { Context } from 'react'
import { createContext } from 'react'
import type { AdminStateType } from 'storeContext/reducers/admin'
import type { AdminDispatchType } from 'storeContext/actions/admin'

export interface AdminContextValueType {
  state: AdminStateType
  dispatch: AdminDispatchType
}

// Preserve the raw-state default and the existing provider identity.
export const createAdminContext = (initialState: AdminStateType) =>
  createContext(initialState) as unknown as Context<AdminContextValueType>
